<template>
  <div v-if="$companyConfiguration.evaluation.isEnabled()">
    <page-heading
      heading="Каталог оценок 360"
    >
      <span slot="help"></span>
      <div slot="right">
        <div class="el-row--flex">
          <el-button
            type="primary"
            size="small"
            icon="fas fa-plus"
            @click="openEditDialog"
          >
            Добавить оценку 360
          </el-button>
        </div>
      </div>
    </page-heading>

    <el-card>
      <evaluations-component
        ref="evaluationsComponent"
        :on-edit-evaluation="openEditDialog"
      ></evaluations-component>
    </el-card>

    <evaluation-edit-dialog
      ref="editDialog"
      @evaluation-saved="loadEvaluations"
    >
    </evaluation-edit-dialog>
  </div>
</template>

<script>
import EvaluationEditDialog from "@/modules/evaluation/components/evaluation/EvaluationEditDialog.vue";
import EvaluationsComponent from "@/modules/evaluation/components/evaluation/EvaluationsComponent.vue";
import PageHeading from "@/components/PageHeading";

export default {
  name: 'eval-evaluations',
  components: {
    EvaluationsComponent,
    EvaluationEditDialog,
    PageHeading,
  },
  methods: {
    openEditDialog(evaluation = {}) {
      this.$refs.editDialog.open(evaluation);
    },
    loadEvaluations() {
      if (this.$refs.evaluationsComponent) {
        this.$refs.evaluationsComponent.loadEvaluations();
      }
    },
  }
}
</script>

<style scoped lang="scss">
  @import "./src/assets/css/project-variables";
</style>